var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle493(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 148,
    viewBox: "0 0 13 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.492188,
    y: 0.676651,
    width: 12,
    height: 146.647,
    rx: 6,
    fill: "#D7F1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle493);
export default __webpack_public_path__ + "static/media/Rectangle 493.b47a7e41b32eec4ed55451f658bcda66.svg";
export { ForwardRef as ReactComponent };